(function() {
	'use strict';

	var urlParams = new URLSearchParams(window.location.search);

	window.addEventListener('load', function() {


		$.when( loginCheck ).then(function() {
			if (userLoggedIn) {
				if (urlParams.has('return_url')) {
					window.location.replace(urlParams.get('return_url'));
				} else {
					if (data.client_info.acct_type == 10) {
						window.location.replace('/admin/index.html');
					} else {
						window.location.replace('/my_account/index.html');
					}
				}
				$('#login-form').hide();
				$('#login-thanks').show();
			}
		});

		var form = document.getElementById('login-form');
			form.addEventListener('submit', function(event) {
				event.preventDefault();
				event.stopPropagation();

				if (form.checkValidity() === false) {

					// Form is not valid so show errors
					$('#login-err').show();
					var wall = $("#login-err-msg").show();

					// Remove old error messages
					wall.find("p").remove();

					// add new ones
					$.each($('div.invalid-feedback'), function(index, error) {
						wall.append("<p class='customErrors customBtnErr'>" + $(error).text() + "</p>");
					});

				} else {
					// Form is valid so hide errors and submit
					$('#errors,#login-submit-div').hide();
					$('#login-wait').show();

					$.ajax({
						 type: "POST",
						 url: $(form).attr('action'),
						 data: $(form).serialize(), // serializes the form's elements.
						 dataType  : 'json',
						 xhrFields: { withCredentials: true },
						 encode  : true,
						 success: function(data) {
								$('#login-wait').hide();
								if (! data.success) {
									$('#login-err,#login-submit-div').show();
									var wall = $("#login-err-msg");
									wall.find("p").remove();
									wall.append("<p><strong> Error submitting form: " + data.error_msg + "</strong></p>");
								} else {
									$('#login-form').hide();
//									$('#login-thanks').show();
									if (urlParams.has('return_url')) {
										window.location.replace(urlParams.get('return_url'));
									} else {
										if (data.client_info.acct_type == 10) {
											window.location.replace('/admin/index.html');
										} else {
											window.location.replace('/my_account/index.html');
										}
									}
									console.log(data);
								}
						 }
					 });
				}
				form.classList.add('was-validated');
			}, false);

	}, false);


	$(document).on('click', '#session_check', function() {
		$.ajax({
			type  : 'POST',
			url: '/utils/check_status.php',
			dataType  : 'json',
			xhrFields: { withCredentials: true },
			crossDomain: true,
			encode  : true
		})
		.done(function(data) {
			if ( ! data.success) {
				console.log(data);
			} else {
				console.log(data);
				$('#login-form').show();
				$('#login-thanks').hide();
			}
		})
		.fail(function(XMLHttpRequest, textStatus, errorThrown) {
			console.log(XMLHttpRequest);
			console.log(textStatus);
			console.log(errorThrown);
			$('#print_wait').hide();
			$('#print_err_msg').text(textStatus);
			$('#print_err').show();
		});

	});

})();